module.exports = {
    message: {
        homeNavi: 'ホーム',
        aboutNavi: 'について',
        testNavi: 'テストページ',
        hello: 'こんにちは、世界',
        welcome: 'これはVuejsとTypeScriptを使用しているサイトです。現在はホームページとして表示しています。',
        welcomeParagraphs: 'ようこそ！BanG Dream!.moeサイトのホームページです。以前に、ここでNginxのインストールが成功した時のようこそページが表示されていますが、今新しいページは工事中です。お楽しみに。',
    }
}